"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.phoneNumber = exports.personalDetailsConfig = exports.middleName = exports.lastName = exports.firstName = exports.email = exports.dateOfBirth = exports.alternativeEmail = exports.address = exports.PersonalDetailsDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _addressConfig = require("../Address/addressConfig");

var _phoneNumberConfig = require("../PhoneNumber/phoneNumberConfig");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var DateDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.DateDefinition;
});

var EmailFieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.EmailFieldDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var PhoneNumberDefinition = _flowRuntime["default"].tdz(function () {
  return _phoneNumberConfig.PhoneNumberDefinition;
});

var PhoneNumberDisplayDefinition = _flowRuntime["default"].tdz(function () {
  return _phoneNumberConfig.PhoneNumberDisplayDefinition;
});

var AddressDefinition = _flowRuntime["default"].tdz(function () {
  return _addressConfig.AddressDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var title = {
  key: 'title',
  label: 'Title',
  type: 'select',
  items: [{
    key: 'Mr',
    label: 'Mr'
  }, {
    key: 'Miss',
    label: 'Miss'
  }, {
    key: 'Ms',
    label: 'Ms'
  }, {
    key: 'Mrs',
    label: 'Mrs'
  }, {
    key: 'Dr',
    label: 'Dr'
  }, {
    key: 'Mx',
    label: 'Mx'
  }],
  validation: [{
    required: true
  }],
  ui: {
    classes: 'flex-item'
  }
};
exports.title = title;
var firstName = {
  key: 'firstName',
  label: 'First name',
  maxLength: 50,
  type: 'text',
  ui: {
    classes: 'flex-item'
  },
  validation: [{
    required: true
  }]
};
exports.firstName = firstName;
var middleName = {
  key: 'middleName',
  label: 'Middle name(s)',
  maxLength: 50,
  type: 'text',
  ui: {
    classes: 'flex-item'
  },
  validation: []
};
exports.middleName = middleName;
var lastName = {
  key: 'lastName',
  label: 'Last name',
  maxLength: 50,
  type: 'text',
  ui: {
    classes: 'flex-item'
  },
  validation: [{
    required: true
  }]
};
exports.lastName = lastName;
var email = {
  key: 'email',
  label: 'Email address',
  maxLength: 100,
  type: 'email',
  ui: {
    classes: 'row'
  },
  validation: [{
    required: true
  }]
};
exports.email = email;
var alternativeEmail = {
  autoComplete: 'nope',
  key: 'alternativeEmail',
  label: 'Alternative email address',
  maxLength: 100,
  type: 'email',
  ui: {
    classes: 'row'
  },
  validation: [{
    differentTo: 'personalDetails.email'
  }]
};
exports.alternativeEmail = alternativeEmail;
var dateOfBirth = {
  key: 'dateOfBirth',
  label: 'Date of birth',
  type: 'date',
  validation: [{
    age: true
  }]
};
exports.dateOfBirth = dateOfBirth;
var address = {
  key: 'address',
  type: 'address',
  label: 'Address',
  validation: [],
  options: {
    country: true,
    name: false
  }
};
exports.address = address;
var phoneNumber = {
  key: 'phoneNumber',
  type: 'phoneNumber',
  label: 'Phone Number'
};
exports.phoneNumber = phoneNumber;
var personalDetailsConfig = {
  type: 'personalDetails',
  subComponents: [address, phoneNumber],
  fields: [title, firstName, middleName, lastName, email, alternativeEmail, dateOfBirth]
};
exports.personalDetailsConfig = personalDetailsConfig;

var PersonalDetailsDefinition = _flowRuntime["default"].type("PersonalDetailsDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("personalDetails")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("address", _flowRuntime["default"].object(_flowRuntime["default"].property("displayed", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("country", _flowRuntime["default"]["boolean"]()))), _flowRuntime["default"].property("dateOfBirth", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("email", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("alternativeEmail", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("middleName", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("phoneNumber", _flowRuntime["default"].ref(PhoneNumberDisplayDefinition)), _flowRuntime["default"].property("title", _flowRuntime["default"]["boolean"]()))))));

exports.PersonalDetailsDefinition = PersonalDetailsDefinition;